import React, { useState, useEffect, Fragment, useRef } from 'react';
import { isIE, isFirefox, isOpera } from 'react-device-detect';
import { MdPause, MdPlayArrow, MdVolumeOff, MdVolumeUp, MdSubtitles, MdOpenInNew, MdFullscreenExit, MdFullscreen } from 'react-icons/md';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // A type of promise-like that resolves synchronously and supports only one observer


var _iteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";

var _asyncIteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously call a function and send errors to recovery continuation


function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function PlayerControls(_ref) {
  var toggleVideoPlay = _ref.toggleVideoPlay,
      playerStatus = _ref.playerStatus,
      handleChangePercentage = _ref.handleChangePercentage,
      handleInputMouseDown = _ref.handleInputMouseDown,
      handleInputMouseUp = _ref.handleInputMouseUp,
      toggleFullscreen = _ref.toggleFullscreen,
      handlePictureInPicture = _ref.handlePictureInPicture,
      showCaptions = _ref.showCaptions,
      handleMuteVolume = _ref.handleMuteVolume,
      handleVolumeChange = _ref.handleVolumeChange;

  var _useState = useState(true),
      pictureInPictureSupport = _useState[0],
      setPictureInPictureSupport = _useState[1];

  useEffect(function () {
    setPictureInPictureSupport(!(isIE || isFirefox || isOpera));
  }, []);

  function handleVolumeBar() {
    return playerStatus.isMuted ? 0 : playerStatus.volume;
  }

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "vpfr_player_controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "vpfr_player_item"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: toggleVideoPlay
  }, playerStatus.playing ? /*#__PURE__*/React.createElement(MdPause, {
    "aria-hidden": "true",
    focusable: "false",
    size: 24,
    style: {
      padding: '6px'
    }
  }) : /*#__PURE__*/React.createElement(MdPlayArrow, {
    "aria-hidden": "true",
    focusable: "false",
    size: 24,
    style: {
      padding: '6px'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "vpfr_player_item vpfr_time_progress"
  }, /*#__PURE__*/React.createElement("div", {
    className: "vpfr_timers"
  }, playerStatus.currentTime), /*#__PURE__*/React.createElement("div", {
    className: "vpfr_time_progress_fields"
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: "0",
    max: "100",
    step: "0.01",
    className: "vpfr_time_progress_bar",
    onMouseDown: handleInputMouseDown,
    onChange: handleChangePercentage,
    onMouseUp: handleInputMouseUp,
    value: playerStatus.currentPercentage,
    role: "slider",
    "aria-label": "Seek",
    style: {
      '--progress': playerStatus.currentPercentage + "%"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "vpfr_timers"
  }, playerStatus.durationTime)), /*#__PURE__*/React.createElement("div", {
    className: "vpfr_player_item vpfr_volume"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleMuteVolume
  }, playerStatus.isMuted ? /*#__PURE__*/React.createElement(MdVolumeOff, {
    "aria-hidden": "true",
    focusable: "false",
    size: 22,
    style: {
      padding: '7px'
    }
  }) : /*#__PURE__*/React.createElement(MdVolumeUp, {
    "aria-hidden": "true",
    focusable: "false",
    size: 22,
    style: {
      padding: '7px'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "vpfr_volume_progress_fields"
  }, /*#__PURE__*/React.createElement("input", {
    className: "vpfr_volume_progress_bar",
    type: "range",
    min: "0",
    max: "100",
    value: handleVolumeBar(),
    onChange: handleVolumeChange,
    style: {
      '--progress': handleVolumeBar() + "%"
    }
  }))), showCaptions && /*#__PURE__*/React.createElement("div", {
    className: "vpfr_player_item vpfr_captions"
  }, /*#__PURE__*/React.createElement("button", null, /*#__PURE__*/React.createElement(MdSubtitles, {
    "aria-hidden": "true",
    focusable: "false",
    size: 22,
    style: {
      padding: '7px'
    }
  }))), pictureInPictureSupport && /*#__PURE__*/React.createElement("div", {
    className: "vpfr_player_item vpfr_picture_in_picture"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handlePictureInPicture
  }, /*#__PURE__*/React.createElement(MdOpenInNew, {
    "aria-hidden": "true",
    focusable: "false",
    size: 22,
    style: {
      padding: '7px'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "vpfr_player_item vpfr_fullscreen"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: toggleFullscreen
  }, playerStatus.isFullscreen ? /*#__PURE__*/React.createElement(MdFullscreenExit, {
    "aria-hidden": "true",
    focusable: "false"
  }) : /*#__PURE__*/React.createElement(MdFullscreen, {
    "aria-hidden": "true",
    focusable: "false"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "vpfr_play_pause_on_click",
    onClick: toggleVideoPlay
  }));
}

function OverlayPlayButton(_ref) {
  var toggleVideoPlay = _ref.toggleVideoPlay,
      playerStatus = _ref.playerStatus;
  return /*#__PURE__*/React.createElement("button", {
    className: "vpfr_overlay_play_button",
    onClick: toggleVideoPlay,
    style: {
      opacity: playerStatus ? '0' : '1'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "90",
    height: "90",
    viewBox: "-5 -5 90 90",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6749 43.1702L25.0894 63.1813C21.9846 64.8778 18 62.8236 18 59.4035V19.3813C18 15.9667 21.9788 13.907 25.0894 15.6089L61.6749 35.62C62.3811 36.0001 62.9682 36.5495 63.3766 37.2125C63.7849 37.8755 64 38.6285 64 39.3951C64 40.1618 63.7849 40.9148 63.3766 41.5778C62.9682 42.2408 62.3811 42.7902 61.6749 43.1702V43.1702Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: "-2",
    y: "-5",
    width: "86",
    height: "88.7879",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "80",
    height: "80",
    fill: "white"
  })))));
}

function parseToTime(time) {
  var fullTime = new Date(time * 1000).toISOString().substr(11, 8);

  if (fullTime.substr(0, 3) === '00:') {
    return fullTime.substr(3);
  }

  return fullTime;
}

var checkFullscreen = function checkFullscreen() {
  var fullscreen = false;

  if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || document.mozFullScreen || document.webkitIsFullScreene || document.fullScreenMode) {
    fullscreen = true;
  }

  return fullscreen;
};

var triggerFullscreen = function triggerFullscreen($videoContainer, isFullscreen) {
  var el = $videoContainer.current;

  if (!isFullscreen) {
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.mozRequestFullScreen) {
      el.mozRequestFullScreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    } else if (el.msRequestFullscreen) {
      el.msRequestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }
};

var mouseIsPressed = false;

function usePlayerState($videoPlayer, $videoContainer) {
  var handlePictureInPicture = function handlePictureInPicture() {
    try {
      var _temp2 = _catch(function () {
        return Promise.resolve($videoPlayer.current.requestPictureInPicture()).then(function () {
          setPlayerStatus(_extends({}, playerStatus, {
            isPIP: !playerStatus.isPIP
          }));
        });
      }, function (error) {
        console.log('Error to start Picture in Picture. ' + error);
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var _useState = useState({
    playing: false,
    stopped: true,
    duration: 0,
    currentPercentage: 0,
    currentTimeSeconds: 0,
    currentTime: '00:00',
    durationTime: '00:00',
    isFullscreen: false,
    isPIP: false,
    isMuted: false,
    volume: 100
  }),
      playerStatus = _useState[0],
      setPlayerStatus = _useState[1];

  useEffect(function () {
    playerStatus.playing ? playAndPause('play') : playAndPause('pause');
  }, [$videoPlayer, playerStatus.playing]);
  useEffect(function () {
    if (playerStatus.isMuted) {
      setPlayerVolume(0);
    } else if (!playerStatus.isMuted && playerStatus.volume === 0) {
      setPlayerStatus(_extends({}, playerStatus, {
        volume: 100
      }));
    } else {
      setPlayerVolume(playerStatus.volume);
    }
  }, [$videoPlayer, playerStatus.isMuted]);
  useEffect(function () {
    if (playerStatus.volume > 0) {
      if (playerStatus.isMuted) {
        setPlayerStatus(_extends({}, playerStatus, {
          isMuted: false
        }));
      }

      setPlayerVolume(playerStatus.volume);
    } else {
      setPlayerStatus(_extends({}, playerStatus, {
        isMuted: true
      }));
    }
  }, [$videoPlayer, playerStatus.volume]);

  function playAndPause(status) {
    $videoPlayer.current[status]();
    status === 'play' && setPlayerStatus(_extends({}, playerStatus, {
      stopped: false
    }));
  }

  useEffect(function () {
    var currentTime = $videoPlayer.current.currentTime;
    var time = currentTime === playerStatus.duration ? 0 : currentTime;
    setPlayerStatus(_extends({}, playerStatus, {
      currentTimeSeconds: time
    }));
  }, [$videoPlayer, playerStatus.currentPercentage]);

  function toggleVideoPlay() {
    !playerStatus.playing ? playAndPause('play') : playAndPause('pause');
    setPlayerStatus(_extends({}, playerStatus, {
      playing: !playerStatus.playing
    }));
  }

  function handleInputMouseDown() {
    mouseIsPressed = true;
  }

  function handleInputMouseUp() {
    mouseIsPressed = false;
    var duration = $videoPlayer.current.duration;
    $videoPlayer.current.currentTime = duration / 100 * playerStatus.currentPercentage;
  }

  function handleTimeUpdate() {
    if (!mouseIsPressed) {
      var currentTime = $videoPlayer.current.currentTime;
      var duration = $videoPlayer.current.duration;
      var percentage = Number(currentTime / duration * 100);
      setPlayerStatus(_extends({}, playerStatus, {
        currentTimeSeconds: currentTime,
        currentPercentage: percentage,
        currentTime: parseToTime(currentTime)
      }));
    }
  }

  function handleChangePercentage(event) {
    var currentPercentageValue = Number(event.target.value);
    setPlayerStatus(_extends({}, playerStatus, {
      currentPercentage: currentPercentageValue
    }));
  }

  function handleResetVideo() {
    setPlayerStatus(_extends({}, playerStatus, {
      playing: false,
      currentPercentage: 0,
      stopped: true
    }));
  }

  function isPlayerStopped() {
    if (playerStatus.stopped && playerStatus.currentPercentage === 0) {
      return 'vpfr_stopped_player';
    } else if (playerStatus.playing) {
      return 'vpfr_hide_controls';
    } else {
      return 'vpfr_paused_player';
    }
  }

  function handleDurationChange() {
    var duration = $videoPlayer.current.duration;
    setPlayerStatus(_extends({}, playerStatus, {
      duration: duration,
      durationTime: parseToTime(duration)
    }));
  }

  function handleFullscreenChange() {
    var fullscreen = checkFullscreen();
    setPlayerStatus(_extends({}, playerStatus, {
      isFullscreen: fullscreen
    }));
  }

  function toggleFullscreen() {
    triggerFullscreen($videoContainer, playerStatus.isFullscreen);
  }

  useEffect(function () {
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);
    document.addEventListener('fullscreenchange', handleFullscreenChange, false);
  }, []);

  function handleOnPlayAndPause() {
    setPlayerStatus(_extends({}, playerStatus, {
      playing: !$videoPlayer.current.paused
    }));
  }

  function handleMuteVolume() {
    setPlayerStatus(_extends({}, playerStatus, {
      isMuted: !playerStatus.isMuted
    }));
  }

  function handleVolumeChange(event) {
    var volume = Number(event.target.value);
    setPlayerStatus(_extends({}, playerStatus, {
      volume: volume
    }));
  }

  function setPlayerVolume(volume) {
    $videoPlayer.current.volume = volume / 100;
  }

  return {
    playerStatus: playerStatus,
    toggleVideoPlay: toggleVideoPlay,
    handleTimeUpdate: handleTimeUpdate,
    handleChangePercentage: handleChangePercentage,
    handleInputMouseDown: handleInputMouseDown,
    handleInputMouseUp: handleInputMouseUp,
    handleResetVideo: handleResetVideo,
    isPlayerStopped: isPlayerStopped,
    handleDurationChange: handleDurationChange,
    toggleFullscreen: toggleFullscreen,
    handlePictureInPicture: handlePictureInPicture,
    handleOnPlayAndPause: handleOnPlayAndPause,
    handleMuteVolume: handleMuteVolume,
    handleVolumeChange: handleVolumeChange
  };
}

var ReactVideoPlayer = function ReactVideoPlayer(_ref) {
  var width = _ref.width,
      height = _ref.height,
      url = _ref.url,
      type = _ref.type,
      poster = _ref.poster,
      captions = _ref.captions;
  var $videoPlayer = useRef(null);
  var $videoContainer = useRef(null);

  var _usePlayerState = usePlayerState($videoPlayer, $videoContainer),
      playerStatus = _usePlayerState.playerStatus,
      toggleVideoPlay = _usePlayerState.toggleVideoPlay,
      handleTimeUpdate = _usePlayerState.handleTimeUpdate,
      handleChangePercentage = _usePlayerState.handleChangePercentage,
      handleInputMouseDown = _usePlayerState.handleInputMouseDown,
      handleInputMouseUp = _usePlayerState.handleInputMouseUp,
      handleResetVideo = _usePlayerState.handleResetVideo,
      isPlayerStopped = _usePlayerState.isPlayerStopped,
      handleDurationChange = _usePlayerState.handleDurationChange,
      toggleFullscreen = _usePlayerState.toggleFullscreen,
      handlePictureInPicture = _usePlayerState.handlePictureInPicture,
      handleOnPlayAndPause = _usePlayerState.handleOnPlayAndPause,
      handleMuteVolume = _usePlayerState.handleMuteVolume,
      handleVolumeChange = _usePlayerState.handleVolumeChange;

  var tracks = captions && captions.map(function (caption) {
    return /*#__PURE__*/React.createElement("track", {
      key: caption.srcLang,
      kind: caption.kind,
      label: caption.label,
      srcLang: caption.srcLang,
      src: caption.src
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    tabIndex: "0",
    className: "vpfr_container " + isPlayerStopped(),
    ref: $videoContainer
  }, /*#__PURE__*/React.createElement(PlayerControls, {
    toggleVideoPlay: toggleVideoPlay,
    playerStatus: playerStatus,
    handleChangePercentage: handleChangePercentage,
    handleInputMouseDown: handleInputMouseDown,
    handleInputMouseUp: handleInputMouseUp,
    toggleFullscreen: toggleFullscreen,
    handlePictureInPicture: handlePictureInPicture,
    showCaptions: captions,
    handleMuteVolume: handleMuteVolume,
    handleVolumeChange: handleVolumeChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "vpfr_video_wrapper"
  }, /*#__PURE__*/React.createElement("video", {
    controls: false,
    crossOrigin: "true",
    preload: "metadata",
    width: !playerStatus.isFullscreen && width,
    height: height || undefined,
    ref: $videoPlayer,
    onTimeUpdate: handleTimeUpdate,
    onEnded: handleResetVideo,
    onDurationChange: handleDurationChange,
    onPause: handleOnPlayAndPause,
    onPlay: handleOnPlayAndPause,
    className: "vpfr_video",
    poster: poster || 'none'
  }, /*#__PURE__*/React.createElement("source", {
    src: url,
    type: type
  }), captions && tracks), poster && /*#__PURE__*/React.createElement("div", {
    className: "vpfr_video_poster_image",
    style: {
      backgroundImage: "url(" + poster + ")"
    }
  })), captions && /*#__PURE__*/React.createElement("div", {
    className: "vpfr_video_captions"
  }, /*#__PURE__*/React.createElement("span", {
    className: "vpfr_caption_text"
  }, "Exemplo de legenda")), /*#__PURE__*/React.createElement(OverlayPlayButton, {
    toggleVideoPlay: toggleVideoPlay,
    playerStatus: playerStatus.playing
  }));
};

export { ReactVideoPlayer };